/**
 * 各分校地址
 */
const us = require('assets/images/footer/us.png');
const uk = require('assets/images/footer/uk.png');
const sg = require('assets/images/footer/sg.png');
const hk = require('assets/images/footer/hk.png');
const au = require('assets/images/footer/au.png');
const my = require('assets/images/footer/ma.png');
const ca = require('assets/images/footer/ca.png');
const jp = require('assets/images/footer/ja.png');
const kr = require('assets/images/footer/kr.png');
const fr = require('assets/images/footer/fr.png');
// const tmc = require('assets/images/footer/tmc.png');
const bmus = require('assets/images/footer/bmus.png');

const usOnline = require('assets/images/footer/us.png');
const ukOnline = require('assets/images/footer/uk-online.png');
const sgOnline = require('assets/images/footer/sg-online.png');
const auOnline = require('assets/images/footer/au-online.png');
const myOnline = require('assets/images/footer/ma-online.png');
const caOnline = require('assets/images/footer/ca-online.png');
const jpOnline = require('assets/images/footer/jp-online.png');
const krOnline = require('assets/images/footer/kr-online.png');
const frOnline = require('assets/images/footer/fr-online.png');
const bmusOnline = require('assets/images/footer/bmus-online.png');
const hkOnline = require('assets/images/footer/hk-online.png');

export default {
  url: [
    {
      locale: 'us',
      url: 'https://www.thethinkacademy.com',
      target: '_blank',
      nationalflag: us,
      onlineflag: usOnline,
      name: {
        us: 'Think Academy United States',
        uk: 'Think Academy United States',
        sg: 'Think Academy United States',
        hk: '美國分校',
        tmc: 'Think Academy United States',
        au: 'Think Academy United States',
        my: 'Think Academy United States',
        ca: 'Think Academy United States',
        tc: 'Think Academy United States',
        tm: 'Think Academy United States',
        jp: 'Think Academy United States',
        kr: 'Think Academy United States',
        fr: 'Think Academy United States',
      },
      newName: {
        us: 'United States',
        uk: 'United States',
        sg: 'United States',
        hk: '美國分校',
        tmc: 'United States',
        au: 'United States',
        my: 'United States',
        ca: 'United States',
        tc: 'United States',
        tm: 'United States',
        jp: 'United States',
        kr: 'United States',
        fr: 'United States',
      },
      onLineName: {
        us: 'Think Academy United States',
        uk: 'Think Academy United States',
        sg: 'Think Academy United States',
        hk: '美國分校',
        tmc: 'Think Academy United States',
        au: 'Think Academy United States',
        my: 'Think Academy United States',
        ca: 'Think Academy United States',
        tc: 'Think Academy United States',
        tm: 'Think Academy United States',
        jp: 'Think Academy United States',
        kr: 'Think Academy United States',
        fr: 'Think Academy United States',
      },
    },
    {
      locale: 'uk',
      url: 'https://www.thinkacademy.uk',
      target: '_blank',
      nationalflag: uk,
      onlineflag: ukOnline,
      name: {
        us: 'Think Academy United Kingdom',
        uk: 'Think Academy United Kingdom',
        sg: 'Think Academy United Kingdom',
        hk: '英國分校',
        tmc: 'Think Academy United Kingdom',
        au: 'Think Academy United Kingdom',
        my: 'Think Academy United Kingdom',
        ca: 'Think Academy United Kingdom',
        tc: 'Think Academy United Kingdom',
        tm: 'Think Academy United Kingdom',
        jp: 'Think Academy United Kingdom',
        kr: 'Think Academy United Kingdom',
        fr: 'Think Academy United Kingdom',
      },
      newName: {
        us: 'United Kingdom',
        uk: 'United Kingdom',
        sg: 'United Kingdom',
        hk: '英國分校',
        tmc: 'United Kingdom',
        au: 'United Kingdom',
        my: 'United Kingdom',
        ca: 'United Kingdom',
        tc: 'United Kingdom',
        tm: 'United Kingdom',
        jp: 'United Kingdom',
        kr: 'United Kingdom',
        fr: 'United Kingdom',
      },
      onLineName: {
        us: 'Think Academy United Kingdom',
        uk: 'Think Academy United Kingdom',
        sg: 'Think Academy United Kingdom',
        hk: '英國分校',
        tmc: 'Think Academy United Kingdom',
        au: 'Think Academy United Kingdom',
        my: 'Think Academy United Kingdom',
        ca: 'Think Academy United Kingdom',
        tc: 'Think Academy United Kingdom',
        tm: 'Think Academy United Kingdom',
        jp: 'Think Academy United Kingdom',
        kr: 'Think Academy United Kingdom',
        fr: 'Think Academy United Kingdom',
      },
    },
    {
      locale: 'sg',
      url: 'https://www.thinkacademy.sg',
      target: '_blank',
      nationalflag: sg,
      onlineflag: sgOnline,
      name: {
        us: 'Think Academy Singapore',
        uk: 'Think Academy Singapore',
        sg: 'Think Academy Singapore',
        hk: '新加坡分校',
        tmc: 'Think Academy Singapore',
        au: 'Think Academy Singapore',
        my: 'Think Academy Singapore',
        ca: 'Think Academy Singapore',
        tc: 'Think Academy Singapore',
        tm: 'Think Academy Singapore',
        jp: 'Think Academy Singapore',
        kr: 'Think Academy Singapore',
        fr: 'Think Academy Singapore',
      },
      newName: {
        us: 'Singapore',
        uk: 'Singapore',
        sg: 'Singapore',
        hk: '新加坡分校',
        tmc: 'Singapore',
        au: 'Singapore',
        my: 'Singapore',
        ca: 'Singapore',
        tc: 'Singapore',
        tm: 'Singapore',
        jp: 'Singapore',
        kr: 'Singapore',
        fr: 'Singapore',
      },
      onLineName: {
        us: 'Think Academy Singapore',
        uk: 'Think Academy Singapore',
        sg: 'Think Academy Singapore',
        hk: '新加坡分校',
        tmc: 'Think Academy Singapore',
        au: 'Think Academy Singapore',
        my: 'Think Academy Singapore',
        ca: 'Think Academy Singapore',
        tc: 'Think Academy Singapore',
        tm: 'Think Academy Singapore',
        jp: 'Think Academy Singapore',
        kr: 'Think Academy Singapore',
        fr: 'Think Academy Singapore',
      },
    },
    {
      locale: 'au',
      url: 'https://au.thethinkacademy.com',
      target: '_blank',
      nationalflag: au,
      onlineflag: auOnline,
      name: {
        us: 'Think Academy Australia',
        uk: 'Think Academy Australia',
        sg: 'Think Academy Australia',
        hk: '澳大利亞分校',
        tmc: 'Think Academy Australia',
        au: 'Think Academy Australia',
        my: 'Think Academy Australia',
        ca: 'Think Academy Australia',
        tc: 'Think Academy Australia',
        tm: 'Think Academy Australia',
        jp: 'Think Academy Australia',
        kr: 'Think Academy Australia',
        fr: 'Think Academy Australia',
      },
      newName: {
        us: 'Australia',
        uk: 'Australia',
        sg: 'Australia',
        hk: '澳大利亞分校',
        tmc: 'Australia',
        au: 'Australia',
        my: 'Australia',
        ca: 'Australia',
        tc: 'Australia',
        tm: 'Australia',
        jp: 'Australia',
        kr: 'Australia',
        fr: 'Australia',
      },
      onLineName: {
        us: 'Think Academy Australia',
        uk: 'Think Academy Australia',
        sg: 'Think Academy Australia',
        hk: '澳大利亞分校',
        tmc: 'Think Academy Australia',
        au: 'Think Academy Australia',
        my: 'Think Academy Australia',
        ca: 'Think Academy Australia',
        tc: 'Think Academy Australia',
        tm: 'Think Academy Australia',
        jp: 'Think Academy Australia',
        kr: 'Think Academy Australia',
        fr: 'Think Academy Australia',
      },
    },
    {
      locale: 'my',
      url: 'https://thinkacademymy.com',
      target: '_blank',
      nationalflag: my,
      onlineflag: myOnline,
      name: {
        us: 'Think Academy Malaysia',
        uk: 'Think Academy Malaysia',
        sg: 'Think Academy Malaysia',
        hk: '馬來西亞分校',
        tmc: 'Think Academy Malaysia',
        au: 'Think Academy Malaysia',
        my: 'Think Academy Malaysia',
        ca: 'Think Academy Malaysia',
        tc: 'Think Academy Malaysia',
        tm: 'Think Academy Malaysia',
        jp: 'Think Academy Malaysia',
        kr: 'Think Academy Malaysia',
        fr: 'Think Academy Malaysia',
      },
      newName: {
        us: 'Malaysia',
        uk: 'Malaysia',
        sg: 'Malaysia',
        hk: '馬來西亞分校',
        tmc: 'Malaysia',
        au: 'Malaysia',
        my: 'Malaysia',
        ca: 'Malaysia',
        tc: 'Malaysia',
        tm: 'Malaysia',
        jp: 'Malaysia',
        kr: 'Malaysia',
        fr: 'Malaysia',
      },
      onLineName: {
        us: 'Think Academy Malaysia',
        uk: 'Think Academy Malaysia',
        sg: 'Think Academy Malaysia',
        hk: '馬來西亞分校',
        tmc: 'Think Academy Malaysia',
        au: 'Think Academy Malaysia',
        my: 'Think Academy Malaysia',
        ca: 'Think Academy Malaysia',
        tc: 'Think Academy Malaysia',
        tm: 'Think Academy Malaysia',
        jp: 'Think Academy Malaysia',
        kr: 'Think Academy Malaysia',
        fr: 'Think Academy Malaysia',
      },
    },
    {
      locale: 'ca',
      url: 'https://www.thinkacademy.ca',
      target: '_blank',
      nationalflag: ca,
      onlineflag: caOnline,
      name: {
        us: 'Think Academy Canada',
        uk: 'Think Academy Canada',
        sg: 'Think Academy Canada',
        hk: '加拿大分校',
        tmc: 'Think Academy Canada',
        au: 'Think Academy Canada',
        my: 'Think Academy Canada',
        ca: 'Think Academy Canada',
        tc: 'Think Academy Canada',
        tm: 'Think Academy Canada',
        jp: 'Think Academy Canada',
        kr: 'Think Academy Canada',
        fr: 'Think Academy Canada',
      },
      newName: {
        us: 'Canada',
        uk: 'Canada',
        sg: 'Canada',
        hk: '加拿大分校',
        tmc: 'Canada',
        au: 'Canada',
        my: 'Canada',
        ca: 'Canada',
        tc: 'Canada',
        tm: 'Canada',
        jp: 'Canada',
        kr: 'Canada',
        fr: 'Canada',
      },
      onLineName: {
        us: 'Think Academy Canada',
        uk: 'Think Academy Canada',
        sg: 'Think Academy Canada',
        hk: '加拿大分校',
        tmc: 'Think Academy Canada',
        au: 'Think Academy Canada',
        my: 'Think Academy Canada',
        ca: 'Think Academy Canada',
        tc: 'Think Academy Canada',
        tm: 'Think Academy Canada',
        jp: 'Think Academy Canada',
        kr: 'Think Academy Canada',
        fr: 'Think Academy Canada',
      },
    },
    {
      locale: 'jp',
      url: 'https://jp.thethinkacademy.com',
      target: '_blank',
      nationalflag: jp,
      onlineflag: jpOnline,
      name: {
        us: 'Think Academy Japan',
        uk: 'Think Academy Japan',
        sg: 'Think Academy Japan',
        hk: '日本分校',
        tmc: 'Think Academy Japan',
        au: 'Think Academy Japan',
        my: 'Think Academy Japan',
        ca: 'Think Academy Japan',
        tc: 'Think Academy Japan',
        tm: 'Think Academy Japan',
        jp: 'Think Academy Japan',
        kr: 'Think Academy Japan',
        fr: 'Think Academy Japan',
      },
      newName: {
        us: 'Japan',
        uk: 'Japan',
        sg: 'Japan',
        hk: '日本分校',
        tmc: 'Japan',
        au: 'Japan',
        my: 'Japan',
        ca: 'Japan',
        tc: 'Japan',
        tm: 'Japan',
        jp: 'Japan',
        kr: 'Japan',
        fr: 'Japan',
      },
      onLineName: {
        us: 'Think Academy Japan',
        uk: 'Think Academy Japan',
        sg: 'Think Academy Japan',
        hk: '日本分校',
        tmc: 'Think Academy Japan',
        au: 'Think Academy Japan',
        my: 'Think Academy Japan',
        ca: 'Think Academy Japan',
        tc: 'Think Academy Japan',
        tm: 'Think Academy Japan',
        jp: 'Think Academy Japan',
        kr: 'Think Academy Japan',
        fr: 'Think Academy Japan',
      },
    },
    {
      locale: 'kr',
      url: 'https://kr.thethinkacademy.com',
      target: '_blank',
      nationalflag: kr,
      onlineflag: krOnline,
      name: {
        us: 'Think Academy South Korea',
        uk: 'Think Academy South Korea',
        sg: 'Think Academy South Korea',
        hk: '韓國分校',
        tmc: 'Think Academy South Korea',
        au: 'Think Academy South Korea',
        my: 'Think Academy South Korea',
        ca: 'Think Academy South Korea',
        tc: 'Think Academy South Korea',
        tm: 'Think Academy South Korea',
        jp: 'Think Academy South Korea',
        kr: 'Think Academy South Korea',
        fr: 'Think Academy South Korea',
      },
      newName: {
        us: 'South Korea',
        uk: 'South Korea',
        sg: 'South Korea',
        hk: '韓國分校',
        tmc: 'South Korea',
        au: 'South Korea',
        my: 'South Korea',
        ca: 'South Korea',
        tc: 'South Korea',
        tm: 'South Korea',
        jp: 'South Korea',
        kr: 'South Korea',
        fr: 'South Korea',
      },
      onLineName: {
        us: 'Think Academy South Korea',
        uk: 'Think Academy South Korea',
        sg: 'Think Academy South Korea',
        hk: '韓國分校',
        tmc: 'Think Academy South Korea',
        au: 'Think Academy South Korea',
        my: 'Think Academy South Korea',
        ca: 'Think Academy South Korea',
        tc: 'Think Academy South Korea',
        tm: 'Think Academy South Korea',
        jp: 'Think Academy South Korea',
        kr: 'Think Academy South Korea',
        fr: 'Think Academy South Korea',
      },
    },
    {
      locale: 'fr',
      url: 'https://fr.thethinkacademy.com',
      target: '_blank',
      nationalflag: fr,
      onlineflag: frOnline,
      name: {
        us: 'Think Academy France',
        uk: 'Think Academy France',
        sg: 'Think Academy France',
        hk: '法國分校',
        tmc: 'Think Academy France',
        au: 'Think Academy France',
        my: 'Think Academy France',
        ca: 'Think Academy France',
        tc: 'Think Academy France',
        tm: 'Think Academy France',
        jp: 'Think Academy France',
        kr: 'Think Academy France',
        fr: 'Think Academy France',
      },
      newName: {
        us: 'France',
        uk: 'France',
        sg: 'France',
        hk: '法國分校',
        tmc: 'France',
        au: 'France',
        my: 'France',
        ca: 'France',
        tc: 'France',
        tm: 'France',
        jp: 'France',
        kr: 'France',
        fr: 'France',
      },
      onLineName: {
        us: 'Think Academy France',
        uk: 'Think Academy France',
        sg: 'Think Academy France',
        hk: '法國分校',
        tmc: 'Think Academy France',
        au: 'Think Academy France',
        my: 'Think Academy France',
        ca: 'Think Academy France',
        tc: 'Think Academy France',
        tm: 'Think Academy France',
        jp: 'Think Academy France',
        kr: 'Think Academy France',
        fr: 'Think Academy France',
      },
    },
    // {
    //   locale: 'tmc',
    //   url: 'https://globalmathclub.com',
    //   target: '_blank',
    //   nationalflag: tmc,
    //   name: {
    //     us: 'Mathink Club',
    //     uk: 'Mathink Club',
    //     sg: 'Mathink Club',
    //     hk: '國際競賽分校',
    //     tmc: 'Mathink Club',
    //     au: 'Mathink Club',
    //     my: 'Mathink Club',
    //     ca: 'Mathink Club',
    //     tc: 'Mathink Club',
    //     tm: 'Mathink Club',
    //     jp: 'Mathink Club',
    //     kr: 'Mathink Club',
    //     fr: 'Mathink Club',
    //   },
    //   newName: {
    //     us: 'Mathink Club',
    //     uk: 'Mathink Club',
    //     sg: 'Mathink Club',
    //     hk: '國際競賽分校',
    //     tmc: 'Mathink Club',
    //     au: 'Mathink Club',
    //     my: 'Mathink Club',
    //     ca: 'Mathink Club',
    //     tc: 'Mathink Club',
    //     tm: 'Mathink Club',
    //     jp: 'Mathink Club',
    //     kr: 'Mathink Club',
    //     fr: 'Mathink Club',
    //   },
    // },
    {
      locale: 'bmus',
      url: 'https://www.bettermeedu.com/',
      target: '_blank',
      nationalflag: bmus,
      onlineflag: bmusOnline,
      name: {
        us: 'BetterMe Math',
      },
      newName: {
        us: 'BetterMe Math',
      },
      onLineName: {
        us: 'BetterMe Math',
      },
    },
    {
      locale: 'hk',
      url: 'https://hk.thethinkacademy.com',
      target: '_blank',
      nationalflag: hk,
      onlineflag: hkOnline,
      name: {
        us: 'Think Academy Hong Kong, China',
        uk: 'Think Academy Hong Kong, China',
        sg: 'Think Academy Hong Kong, China',
        hk: '香港分校',
        tmc: 'Think Academy Hong Kong, China',
        au: 'Think Academy Hong Kong, China',
        my: 'Think Academy Hong Kong, China',
        ca: 'Think Academy Hong Kong, China',
        tc: 'Think Academy Hong Kong, China',
        tm: 'Think Academy Hong Kong, China',
        jp: 'Think Academy Hong Kong, China',
        kr: 'Think Academy Hong Kong, China',
        fr: 'Think Academy Hong Kong, China',
      },
      newName: {
        us: 'Hong Kong',
        uk: 'Hong Kong',
        sg: 'Hong Kong',
        hk: '香港分校',
        tmc: 'Hong Kong',
        au: 'Hong Kong',
        my: 'Hong Kong',
        ca: 'Hong Kong',
        tc: 'Hong Kong',
        tm: 'Hong Kong',
        jp: 'Hong Kong',
        kr: 'Hong Kong',
        fr: 'Hong Kong',
      },
      onLineName: {
        us: 'Think Academy Hong Kong, China',
        uk: 'Think Academy Hong Kong, China',
        sg: 'Think Academy Hong Kong, China',
        hk: '香港分校',
        tmc: 'Think Academy Hong Kong, China',
        au: 'Think Academy Hong Kong, China',
        my: 'Think Academy Hong Kong, China',
        ca: 'Think Academy Hong Kong, China',
        tc: 'Think Academy Hong Kong, China',
        tm: 'Think Academy Hong Kong, China',
        jp: 'Think Academy Hong Kong, China',
        kr: 'Think Academy Hong Kong, China',
        fr: 'Think Academy Hong Kong, China',
      },
    },
  ],
}
